/* eslint-disable no-unused-vars */
import * as React from "react";
/* eslint-enable no-unused-vars */
import { connect } from "react-redux";
import { IApplicationState } from "../../models/store/storeTypes";
import * as storeEffects from "../../models/store/storeEffects";
import { UserIdCardView, IUserIdCardViewOwnProps, IUserIdCardViewStateProps, IUserIdCardViewDispatchProps } from "../../components/userIdCard/userIdCardView";
import { Base } from "ui/Scripts/source/framework/base";

export function mapStateToProps(applicationState: IApplicationState, ownProps: IUserIdCardViewOwnProps): IUserIdCardViewStateProps {
    if (Base.isNullOrUndefined(applicationState) || Base.isNullOrUndefined(applicationState.task) || Base.isNullOrUndefined(applicationState.task.taskList)) {
        return {
            user: null,
            item: null,
        };
    }
    const state = applicationState.idCard;
    return {
        user: applicationState.user,
        item: state.idCardItem
    };
}

export function mapDispatchToProps(dispatch: storeEffects.UserFurtherEducationThunkDispatch): IUserIdCardViewDispatchProps {
    return {
        loadUserIdCardItem: () => dispatch(storeEffects.getUserIdCard()),
        onLogout: () => dispatch(storeEffects.logout())
    };
}

export default connect<IUserIdCardViewStateProps, IUserIdCardViewDispatchProps, IUserIdCardViewOwnProps>(mapStateToProps, mapDispatchToProps)(UserIdCardView);